export const PhysicalDocumentCategoryReadable = {
  drivers_license: "Driver's License",
  id_card: "ID Card",
  passport: "Passport",
  residence_permit_card: "Residence Permit Card",
  resident_card: "Resident Card",
  visa: "Visa"
};
